export enum AdvancedSearchKeys {
  Id = 'id',
  Headline = 'headline',
  Summary = 'summary',
  Story = 'story',
  Source = 'sourceIds',
  Series = 'seriesIds',
  Byline = 'byline',
  Section = 'section',
  Page = 'pageName',
  Status = 'status',
  Edition = 'edition',
  ContentType = 'contentType',
  PublishedOn = 'publishedOn',
  CreatedOn = 'createdOn',
  UpdatedOn = 'updatedOn',
  Body = 'body',
}
